import { IntegrationService } from "../api";

export async function fetchProductPrice(partNo: string | null, numberOfDecimals: number): Promise<string | null> {
	if (!partNo) {
		return null;
	}

	try {
		const response = await IntegrationService.getProductPrice({
			query: {
				itemId: Number(partNo),
				numberOfDecimals: numberOfDecimals,
			},
		});

		if (response.response.status !== 200) {
			return null;
		}

		return response.data?.priceFormatted ?? null;
	} catch (error) {
		console.error("Error fetching product price:", error);
		return null;
	}
}
